import * as React from 'react';
import Footer from '../components/Footer';

export const withFooter = (Component) => (props) => (
    <>
        <Component {...props}/>
        <Footer/>
    </>
);